import type { PastedTextAttachmentSource, SnapShotSource } from "@afar-research/contracts";

export interface ExpandedImageItem {
  src: string;
  name: string;
  /** Present for a SnapShot, so the dialog can show what the window exposed. */
  source?: SnapShotSource;
}

export interface ExpandedImagePreview {
  images: ExpandedImageItem[];
  index: number;
}

export function buildExpandedImagePreview(
  images: ReadonlyArray<{
    id: string;
    name: string;
    previewUrl?: string | undefined;
    source?: SnapShotSource | PastedTextAttachmentSource | undefined;
  }>,
  selectedImageId: string,
): ExpandedImagePreview | null {
  const previewableImages = images.flatMap((image) =>
    image.previewUrl
      ? [
          {
            id: image.id,
            src: image.previewUrl,
            name: image.name,
            // Only a SnapShot has anything for the dialog to show.
            ...(image.source && "kind" in image.source ? { source: image.source } : {}),
          },
        ]
      : [],
  );
  if (previewableImages.length === 0) {
    return null;
  }
  const selectedIndex = previewableImages.findIndex((image) => image.id === selectedImageId);
  if (selectedIndex < 0) {
    return null;
  }
  return {
    images: previewableImages.map((image) => ({
      src: image.src,
      name: image.name,
      ...(image.source ? { source: image.source } : {}),
    })),
    index: selectedIndex,
  };
}

/** Point a <video> at a staged file's bytes; the caller revokes on unmount. */
export function attachVideoThumbnail(video: HTMLVideoElement, file: File): () => void {
  const url = URL.createObjectURL(file);
  video.src = url;
  return () => URL.revokeObjectURL(url);
}
